import React from 'react'
import { Vehicle } from '../../entities/vehicle/Vehicle'
import Map from '../map/Map'
import Marker from '../map/marker/Marker'

export interface IOwnProps { }

export interface IStateProps {
  storeName: string,
  vehicle: Vehicle
}

export interface IDispatchProps { }

export type IProps = IOwnProps & IStateProps & IDispatchProps

const driverIcon = {
  path: 'M11.2 39.95q-2.45 0-4.175-1.7-1.725-1.7-1.725-4.2H2V11q0-1.2.9-2.1Q3.8 8 5 8h28.95v8.35h5.25L46 25.4v8.65h-3.55q0 2.5-1.725 4.2-1.725 1.7-4.175 1.7-2.45 0-4.175-1.7-1.725-1.7-1.725-4.2H17.1q0 2.5-1.725 4.2-1.725 1.7-4.175 1.7Zm0-3q1.2 0 2.05-.85.85-.85.85-2.05 0-1.2-.85-2.05-.85-.85-2.05-.85-1.2 0-2.05.85-.85.85-.85 2.05 0 1.2.85 2.05.85.85 2.05.85Zm25.35 0q1.2 0 2.05-.85.85-.85.85-2.05 0-1.2-.85-2.05-.85-.85-2.05-.85-1.2 0-2.05.85-.85.85-.85 2.05 0 1.2.85 2.05.85.85 2.05.85Zm-2.6-10.2h9.3l-5.55-7.4h-3.75Z',
  fillColor: '#008000',
  fillOpacity: 0.8,
  strokeWeight: 2,
  strokeColor: '#5F6368',
}

const storeIcon = {
  path: 'M8.25 11.35v-3h31.6v3ZM8.5 39.7V27.45H6.05v-3l2.2-10.1H39.8l2.2 10.1v3h-2.45V39.7h-3V27.45H27.6V39.7Zm3-3h13.1v-9.25H11.5Z',
  fillColor: '#FF0000',
  fillOpacity: 0.8,
  strokeWeight: 1,
  strokeColor: '#5F6368',
}

const MapWrapper: React.FC<IProps> = (props) => {
  const {
    vehicle,
    storeName,
  } = props

  const infoWindow = new google.maps.InfoWindow()

  const zoom = 5
  const center = vehicle.geolocation ? { ...vehicle.geolocation } : undefined
  return (
    <Map
      center={center}
      zoom={zoom}
      style={{ flexGrow: '1', height: '70vh' }}
    >
      {vehicle.geolocation &&
        <Marker
          position={{ ...vehicle.geolocation }}
          icon={driverIcon}
          title={vehicle.driverName}
          infoWindow={infoWindow}
        />
      }

      <Marker
        position={{ ...vehicle.vendorGeolocation }}
        icon={storeIcon}
        title={storeName}
        infoWindow={infoWindow}
      />
    </Map>
  )
}

export default MapWrapper